import React from 'react';

export const MenuIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M0.842285 1.26367H15.1581M0.842285 8.00051H15.1581M0.842285 14.7374H15.1581"
        stroke="#4B4B4B"
      />
    </g>
  </svg>
);
